import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'parentFilterPipe' })
export class ParentFilterPipe implements PipeTransform {
    transform(items: any[], args: any[]): any {
        return items.filter(x => x.parentId.indexOf(args[0]) !== -1);
    }
}
